import { safeRemoveLocalStorage, safeGetLocalStorageJson, safeSetLocalStorage } from './safeLocalStorage';
import { getPortalId, LOCAL_STORAGE_THEME_KEY as EXTERNAL_LOCAL_STORAGE_KEY, HUBLESS_LOCAL_STORAGE_THEME_KEY as EXTERNAL_HUBLESS_LOCAL_STORAGE_KEY } from 'foundations-theming-base/setup-theme';
const broadcastThemeChange = () => {
  try {
    const reloadEvent = {
      type: 'trellis:theme'
    };
    window.postMessage(reloadEvent);
    for (let i = 0; i < window.frames.length; i++) {
      if (typeof window.frames[i].postMessage === 'function') {
        window.frames[i].postMessage(reloadEvent);
      }
    }
  } catch (e) {
    console.error('Error updating trellis theme, try reloading the page.');
  }
};
export const removeThemeSetting = () => {
  const portalId = getPortalId();
  if (!portalId) {
    console.warn('No portal ID found, cannot change theme setting.');
    return;
  }
  const currentThemeSetting = safeGetLocalStorageJson(EXTERNAL_LOCAL_STORAGE_KEY);
  if (!(currentThemeSetting !== null && currentThemeSetting !== void 0 && currentThemeSetting[portalId])) {
    return;
  }
  const newThemeSetting = Object.assign({}, currentThemeSetting);
  delete newThemeSetting[portalId];
  if (Object.keys(newThemeSetting).length === 0) {
    safeRemoveLocalStorage(EXTERNAL_LOCAL_STORAGE_KEY);
  } else {
    safeSetLocalStorage(EXTERNAL_LOCAL_STORAGE_KEY, JSON.stringify(newThemeSetting));
  }
};
export const removeHublessThemeSetting = () => {
  safeRemoveLocalStorage(EXTERNAL_HUBLESS_LOCAL_STORAGE_KEY);
};

/**
 * Changes the customers theme.
 * Not read directly by ThemeProvider but rather used indirectly to set `html` data-attribute.
 */
export const changeThemeSetting = (themeName, themeMode) => {
  const portalId = getPortalId();
  if (!portalId) {
    console.warn('No portal ID found, cannot change theme setting.');
    return;
  }
  const currentThemeSetting = safeGetLocalStorageJson(EXTERNAL_LOCAL_STORAGE_KEY);
  const newThemeSetting = Object.assign({}, currentThemeSetting, {
    [portalId]: `${themeName}-${themeMode}`
  });
  safeSetLocalStorage(EXTERNAL_LOCAL_STORAGE_KEY, JSON.stringify(newThemeSetting));
};
export const changeHublessThemeSetting = (themeName, themeMode) => {
  const newThemeSetting = `${themeName}-${themeMode}`;
  safeSetLocalStorage(EXTERNAL_HUBLESS_LOCAL_STORAGE_KEY, newThemeSetting);
};
export const changeThemeSettingWithLiveUpdate = (themeName, themeMode) => {
  changeThemeSetting(themeName, themeMode);
  broadcastThemeChange();
};
const INTERNAL_LOCAL_STORAGE_KEY = 'trellis:theme';
/**
 * @deprecated This changes the theme setting directly in local storage. Do not use this in new code.
 */
export const changeTheme = (themeName, themeMode) => {
  safeSetLocalStorage(INTERNAL_LOCAL_STORAGE_KEY, `${themeName}-${themeMode}`);
};

/**
 * @deprecated This changes the theme setting directly in local storage. Do not use this in new code.
 */
export const changeThemeWithLiveUpdate = (themeName, themeMode) => {
  changeTheme(themeName, themeMode);
  broadcastThemeChange();
};